import axios from '@/libs/api.request'

// 获取注销申请列表
export const getAccountDeleteList = (params) => {
  return axios.request({
    url: '/v2/admin/account_delete/list',
    method: 'get',
    params
  })
}

// 审核注销申请
export const auditAccountDelete = (data) => {
  return axios.request({
    url: '/v2/admin/account_delete/audit',
    method: 'post',
    data
  })
}